import { Skeleton } from "@mui/material";

interface Props {}

export default function OrderHistoryPageSkeletonUI(props: Props) {
	return (
		<>
			<div
				style={{
					flex: "1",
					display: "flex",
					flexDirection: "column",
					gap: "20px",
				}}
			>
				<div style={{ flex: "1 1 0%", position: "relative" }}>
					<Skeleton
						variant="rectangular"
						width={"100%"}
						height={"33%"}
						sx={{ borderRadius: "4px", position: "absolute" }}
					></Skeleton>
				</div>
			</div>
			<div
				style={{
					display: "flex",
					justifyContent: "center",
				}}
			>
				{" "}
				<Skeleton
					variant="rounded"
					width={128}
					height={44}
					sx={{ borderRadius: "30px" }}
				></Skeleton>
			</div>
		</>
	);
}
